
import Vector from "./Vector";

export default class Polygon {
    
    /** @type { Vector[] } */
    #points;

    constructor({ style, points }) {
        this.setStyle(style);
        this.#points = points;
        this.calculateMeasurements();
    }

    setStyle(style) {
        this.style = {
            stroke: {
                color: style?.stroke?.color || this.style.stroke.color || "#ff0000",
                width: style?.stroke?.width || this.style.stroke.width || 2
            },
            fillColor: style?.fillColor || this.style.fillColor || "#f0f0f0"
        };
    }

    get points() { return [...this.#points]; }

    set points(newPoints) {
        this.#points = newPoints;
        this.calculateMeasurements();
    }

    calculateMeasurements() {
        let lowestX = null;
        let highestX;
        let lowestY;
        let highestY;

        for(const { x, y } of this.#points) {
            if(lowestX === null) {
                lowestX = x;
                highestX = x;
                lowestY = y;
                highestY = y;
                continue;
            }

            if(x < lowestX) lowestX = x;
            if(x > highestX) highestX = x;
            if(y < lowestY) lowestY = y;
            if(y > highestY) highestY = y;
        }

        this.bounds = {
            height: highestY - lowestY,
            width: highestX - lowestX,

            topLeft: new Vector(lowestX, highestY),
            topRight: new Vector(highestX, highestY),
            bottomRight: new Vector(highestX, lowestY),
            bottomLeft: new Vector(lowestX, lowestY)
        };

        this.center = new Vector( 
            (lowestX + highestX) / 2,  
            (lowestY + highestY) / 2 
        );
    }
}